export default {
  get_AllService: [],
  selectservice: {},
  get_AllPartner: [],
  get_AllWorkshop: [],
  get_AllBanner: [],
  get_AllhomeBanner: [],
  selectpartner: {},
  selectworkshop: {},
  selectbanner: {},
  selecthomebanner: {},
  setregform: {},
  setreg: {},
  getCareProfs: {},
  getAppForm: {},
  get_service: {},
  getDonors: {},
  getDonorType: {},
  selected_service_card: {},
};
